<template>
  <v-container fluid id="discover-page">
    <v-row class="justify-center">
      <v-col xs="10" md="8" lg="8">
        <h1 id="title">Discover our<br />10 Legendary Kitties</h1>
        <img
          class="mt-n3 mb-1"
          :src="require(`../assets/gold-line.svg`)"
          alt="Gold line"
        />
      </v-col>
      <v-col cols="10" class="mt-n16">
        <VueSlickCarousel v-bind="settings" class="carousel">
          <img
            class="img-slider"
            :src="require(`../assets/cat-1.png`)"
            alt="Cat"
          />
          <img
            class="img-slider-1"
            :src="require(`../assets/cat-2.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
          <img
            class="img-slider"
            :src="require(`../assets/cat-3.png`)"
            alt="Cat"
          />
        </VueSlickCarousel>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  name: "Discover",
  components: { VueSlickCarousel },

  data() {
    return {
      settings: {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 3,
        touchThreshold: 5,
        dots: true,
      },
    };
  },
};
</script>
<style>
.slick-prev {
  z-index: 2 !important;
  margin-top: -55px !important;
}

.slick-dots li button:before {
  color: white !important;
}

.slick-next {
  z-index: 2 !important;
  margin-top: -55px !important;
}
.carousel {
  margin-bottom: 20px;
}
.slick-prev:before {
  content: url(../assets/arrow-left-black.png) !important;
  margin-right: -10vw !important;
  opacity: 0.5 !important;
}
.slick-next:before {
  content: url(../assets/arrow-right-black.png) !important;
  margin-left: -9.8vw !important;
  opacity: 0.5 !important;
}
.img-slider {
  margin: 4.1vw 12px 0 12px !important;
  width: 23vw !important;
}

.img-slider-1 {
  margin: 0 12px 0 12px !important;
  width: 23vw !important;
}
@media screen and (max-width: 961px) {
  .slick-prev:before,
  .slick-next:before {
    display: none;
  }
  .img-slider,
  .img-slider-1 {
    width: 32vw !important;
  }
  .img-slider {
    margin: 5.5vw 12px 0 12px !important;
  }
  .carousel {
    width: 100vw;
    margin-left: -10.7vw;
  }
}
@media screen and (max-width: 600px) {
  #title {
    margin-top: 0px;
  }
  .carousel {
    width: 100vw;
    margin-left: -13.5vw;
    margin-bottom: 20px;
  }
}
</style>
<style scoped>
#title {
  color: white !important;
  margin-top: 3vw !important;
  font-weight: 500 !important;
  font-size: 4vw !important;
  line-height: 4vw !important;
}
#discover-page {
  color: white;
  height: calc(100vh - 80px);
  background: url(../assets/bg-discover.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  text-align: center;
  position: relative;
  overflow: hidden;
}
@media screen and (max-width: 961px) {
  #discover-page {
    width: 100vw;
    margin-top: 0px !important;
  }
  #paragraph {
    font-size: 2vw !important;
    line-height: 2vw !important;
  }
  #title {
    font-size: 7vw !important;
    line-height: 7vw !important;
  }
}
</style>
